import { createReducer, on } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from '../actions';
import { setExportOption } from './export-option.actions';
export const exportOption = createReducer(null, on(setExportOption, (state, action) => {
    return action.exportOption;
}), on(resetAllCustomPdfReportItems, () => {
    return null;
}));
